var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.customClasses,style:(_vm.customStyles),attrs:{"type":"button"},on:{"click":_vm.triggerFunction}},[_vm._v(" "+_vm._s(_vm.field.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }